module.exports = __webpack_public_path__ + "static/media/3.fdc670d6.jpg";